import { Card, Typography, Box } from "@mui/material";

const KycPreview = ({ title, previewUrl, fileName, file }) => {
  if (!previewUrl) return null;

  const isPdf =
    file?.type === "application/pdf" ||
    file?.name?.toLowerCase().endsWith(".pdf") ||
    (fileName && fileName.toLowerCase().endsWith(".pdf")) ||
    (typeof previewUrl === "string" &&
      (previewUrl.toLowerCase().includes(".pdf") || previewUrl.startsWith("data:application/pdf")));

  return (
    <Card sx={{ p: 2, mb: 2 }}>
      <Typography variant="subtitle2" gutterBottom>
        {title}
      </Typography>

      {isPdf ? (
        <iframe
          src={previewUrl}
          title={title}
          style={{
            width: "100%",
            height: 250,
            border: "1px solid #ddd",
            borderRadius: 4,
          }}
        />
      ) : (
        <Box
          component="img"
          src={previewUrl}
          alt={title}
          sx={{
            width: "100%",
            maxHeight: 220,
            objectFit: "contain",
            border: "1px solid #ddd",
            borderRadius: 2,
          }}
        />
      )}
    </Card>
  );
};

export default KycPreview;
